import { IVendorReq } from '@/interfaces/vendor';
import * as baseAdapter from './baseAdapter';

export const searchVendors = async (req: IVendorReq) => {
  const ret = await baseAdapter.post<any>('/v1/misc/vendor/inquiry', req);
  return ret;
};
